import { createFileRoute, Link, Outlet } from '@tanstack/react-router'
import { locations, useLocation } from '@/location/api'
import { ChartOptionsContextProvider } from '@/chartOptions/ChartOptionsContext'
import { usePosthogGroup } from '@/posthog/usePosthogGroup'

export const Route = createFileRoute(
  '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId',
)({
  params: {
    parse: (rawParams) => ({ locationId: parseInt(rawParams.locationId) }),
  },
  component: RouteComponent,
  loader: ({ context: { queryClient }, params: { locationId, organizationId } }) =>
    queryClient.ensureQueryData(locations.detail(locationId, organizationId)),
  staticData: {
    breadcrumb: Breadcrumb,
  },
})

function RouteComponent() {
  const { locationId } = Route.useParams()
  const { data: location } = useLocation(locationId)

  usePosthogGroup('location', location)

  return (
    <ChartOptionsContextProvider location={location}>
      <Outlet />
    </ChartOptionsContextProvider>
  )
}

function Breadcrumb() {
  const { locationId } = Route.useParams()
  const { data: location } = useLocation(locationId)
  return (
    <Link to={Route.fullPath} params={Route.useParams()}>
      {location.name}
    </Link>
  )
}
